module.exports = __webpack_public_path__ + "img/close.8be7fd37.svg";